import { ChannelsFeatures } from './ChannelsFeatures';
export class ChannelBaseController {
    static $inject = ['channelName', 'ChannelsService', 'ApplicationService2', 'application'];
    constructor(channelName, ChannelsService, ApplicationService2, application) {
        this.channelName = channelName;
        this.ChannelsService = ChannelsService;
        this.ApplicationService2 = ApplicationService2;
        this.application = application;
    }
    async $onInit() {
        await this.checkFeatures();
        await this.ChannelsService.init(this.application);
        this.isActive = this.ChannelsService.isChannelActive(this.channelName);
        this.channel = this.ApplicationService2.getChannel(this.channelName, this.application);
        !this.channel && this.initChannel();
        this.initIsNew();
    }
    async updateChannel() {
        this.channel.configurations.IsChannelActive = this.isActive
            ? 'True'
            : 'False';
        await this.ChannelsService.updateChannelConfigurations(this.channel);
        this.isNew = false;
        this.ApplicationService2.computeOrRemoveChannel(this.channel, this.application);
        !this.isActive && this.initChannel();
    }
    async checkFeatures() {
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await ChannelsFeatures.isConfigurationsDomainOnChannelsOperationsGetEnabled();
        this.isConfigurationsApplicationsDomainUsageSetEnabled = await ChannelsFeatures.isConfigurationsDomainOnChannelsOperationsSetEnabled();
    }
    checkAddedFields(primary, secondary, ignoredFields = []) {
        return Object.keys(primary).filter(key => {
            if (ignoredFields.includes(key)) {
                return false;
            }
            return primary[key] && !secondary[key];
        });
    }
    checkChangedFields(primary, secondary, ignoredFields = []) {
        return Object.keys(secondary).filter(key => {
            if (ignoredFields.includes(key)) {
                return false;
            }
            return secondary[key] != primary[key];
        });
    }
    initIsNew() {
        if (this.channel.configurations) {
            this.isNew = false;
        }
        else {
            this.isNew = true;
        }
    }
    initChannel() {
        this.channel = {
            name: this.channelName,
            configurations: {
                IsChannelActive: 'False',
            },
        };
    }
}
ChannelBaseController.$inject = ['channelName', 'ChannelsService', 'ApplicationService2', 'application'];
